import { LoadingSpinner, LoadingSpinnerProps } from '@idexx-laboratories/spot-react';
import React, { forwardRef, ReactNode } from 'react';
import './LoadingSpinnerWithContent.scss';

export interface LoadingSpinnerWithContent extends LoadingSpinnerProps {
  children: ReactNode;
}

export const LoadingSpinnerWithContent = forwardRef<SVGSVGElement, LoadingSpinnerWithContent>(
  ({ children, ...rest }, ref) => (
    <div className='spot-loading-spinner-wrapper'>
      <LoadingSpinner {...rest} ref={ref} />
      <span className='spinner-text'>{children}</span>
    </div>
  ),
);
